
<el-container class="screen-parameters screen-parameters-fullHeight services">
  <el-row class="services-panel black-inputs">
    <el-col :span="20" :offset="2" class="services-container">
      <div class="nav-toggle" @click="showHideScreenServices">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
      <div class="services-addMs-btn">
        <div class="btn-dark btn-top" @click='setVisibilityCreateMainService'>Ajouter un service</div>
      </div>
      <div v-if="showCreateMainService">
        <el-form class="services-addMs-container" ref="formCreateMainService" :model="formCreateMainService"
          label-width="0px">
          <el-form-item>
            <div>Créer un nouveau service :</div>
            <el-input placeholder="Nom du nouveau service" v-model="formCreateMainService.name" />
          </el-form-item>
          <el-button @click="createNewMainService">Créer</el-button>
        </el-form>
      </div>
      <div class="services-tabs">
        <el-radio-group v-model="radioTabSelect">
          <draggable @end="sortTab">
            <el-radio-button class="services-tab" @focus="focusNumber" v-for='ms in getMainServicesWithoutEvents'
              :key="ms.name" :id="ms.name" :label="ms.name">
              <div class="services-tab-title">{{ ms.name }}</div>
              <el-popover placement="right" width="200" trigger="manual" v-model="popupDeleteService[ms.name]"
                popper-class="popup-delete black-inputs">
                <p>Si vous voulez supprimer ce service, merci d'indiquer votre mot de passe</p>
                <el-input v-model="checkPassValue" type="password"></el-input>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" class="dark" type="primary"
                    @click="popupDeleteService[ms.name] = false">Annuler</el-button>
                  <el-button type="primary" size="mini" @click="checkBeforeDelete(ms.name)">Confirmer</el-button>
                </div>
                <el-button slot="reference" @click="popupDeleteService[ms.name] = !popupDeleteService[ms.name]"
                  class="el-icon-close" circle>
                </el-button>
              </el-popover>
            </el-radio-button>
          </draggable>
        </el-radio-group>
      </div>
      <div class="my-tab-pane" v-for='ms in getMainServicesWithoutEvents' :key="ms.name"
        @click="closeAllPopupDelete()">
        <el-row v-if="ms.name === radioTabSelect">
          <el-col class="services-day" v-for='d in getFormatedServicesData["daysSortedById"]' :key="d.idDay">
            <el-row :gutter="40">
              <el-col :span="8">
                <div style="display: flex; width:100%">
                  <h2 style="" @click="visibilityFormOpenClose(d, ms.name)"
                    :class='{ "services-day-close": formatedDataServices[ms.name][d]["form"].isClosed }'>
                    {{ d }}
                    <span v-if="visibilityForm[d][ms.name]"> {{ ms.name }}</span>
                    <span v-if="formatedDataServices[ms.name][d]['form'].isClosed"> - fermé</span>
                  </h2>
                  <h5 style="flex-grow: 1; text-align:center; line-height:24px;"
                    v-if="!visibilityForm[d][ms.name] && formatedDataServices[ms.name][d]['form'].cashOn">
                    <span v-if="formatedDataServices[ms.name][d]['form'].cashType === 'caution'">C :
                      {{ formatedDataServices[ms.name][d]['form'].cashPrice }} €/couv.</span>
                    <span v-else>P : {{ formatedDataServices[ms.name][d]['form'].cashPrice }} €/couv.</span>
                  </h5>
                  <span v-else style="flex-grow: 1;"></span>
                  <h2 style="" @click="visibilityFormOpenClose(d, ms.name)"
                    :class='{ "services-day-close": formatedDataServices[ms.name][d]["form"].isClosed }'>
                    <i class="el-icon-edit" v-if="!visibilityForm[d][ms.name]"></i>
                    <i class="el-icon-arrow-up" v-if="visibilityForm[d][ms.name]"></i>
                  </h2>
                </div>
              </el-col>
              <el-col :span="16" v-if="!formatedDataServices[ms.name][d]['form'].isClosed">
                <div class="services-line">
                  <div class="services-line-centered">
                    <div class="services-line-container">
                      <!-- left -->
                      <div class="services-line-service" style='left:0'>
                        <div class="services-line-point">
                          <span v-if="haveCapacityMin(ms, d)">
                            <el-popover v-if="visibilityForm[d][ms.name]" placement="top" trigger="click"
                              class="black-inputs">
                              <div class="black-inputs">
                                <el-input-number @change="checkIntervalNull(ms.name, d, 0)" :min="-1"
                                  v-model="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity"></el-input-number>
                              </div>
                              <div slot="reference" class="clickBox">
                                {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity }}</div>
                            </el-popover>
                            <span v-else>
                              <span v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity > 0 ||
                                formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity < 0">
                                {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[0].capacity }}
                              </span>
                            </span>
                          </span>
                        </div>
                        <div class="services-line-hour">{{ formatedDataServices[ms.name][d]['form'].opening }}</div>
                      </div>
                      <!-- range -->
                      <div class="services-line-service"
                        v-for="hInter in getNumberOfIntervalServiceDyna(d, formatedDataServices[ms.name][d]['form'])"
                        :key="hInter.id"
                        :style="{ left: ((hInter.id) / (getNumberOfIntervalServiceDyna(d, formatedDataServices[ms.name][d]['form']).length + 1)) * 100 + '%' }">
                        <div v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab &&
                          formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id] &&
                          formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length > 0">
                          <div class="services-line-minipoint"
                            v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity === 0 && !visibilityForm[d][ms.name]">
                          </div>
                          <div class="services-line-point" v-else>
                            <el-popover v-if="visibilityForm[d][ms.name]" placement="top" trigger="click"
                              class="black-inputs">
                              <div class="black-inputs">
                                <el-input-number @change="checkIntervalNull(ms.name, d, hInter.id)" :min="-1"
                                  v-model="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity"></el-input-number>
                              </div>
                              <div slot="reference" class="clickBox">
                                {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity }}
                              </div>
                            </el-popover>
                            <span v-else>
                              <span
                                v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab &&
                                  formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id] &&
                                  (formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity > 0 ||
                                    formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity < 0)">
                                {{ formatedDataServices[ms.name][d]['form'].capacityIntervalTab[hInter.id].capacity }}
                              </span>
                            </span>
                          </div>
                          <div class="services-line-minihour">{{ hInter.hour }}</div>
                        </div>
                        <div v-else>
                          <div class="services-line-minipoint"></div>
                          <div class="services-line-minihour">{{ hInter.hour }}</div>
                        </div>
                      </div>
                      <!-- right -->
                      <div class="services-line-service" style='left:98%'>
                        <div class="services-line-point">
                          <span v-if="haveCapacityMax(ms, d)">
                            <el-popover v-if="visibilityForm[d][ms.name]" placement="top" trigger="click"
                              class="black-inputs">
                              <div class="black-inputs">
                                <el-input-number
                                  @change="checkIntervalNull(ms.name, d, formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1)"
                                  :min="-1"
                                  v-model="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1].capacity"></el-input-number>
                              </div>
                              <div slot="reference" class="clickBox">
                                {{
                                  formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length
                                    - 1].capacity }}</div>
                            </el-popover>
                            <span v-else>
                              <span
                                v-if="formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1].capacity > 0 ||
                                  formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length - 1].capacity < 0">
                                {{
                                  formatedDataServices[ms.name][d]['form'].capacityIntervalTab[formatedDataServices[ms.name][d]['form'].capacityIntervalTab.length
                                    - 1].capacity }}
                              </span>
                            </span>
                          </span>
                        </div>
                        <div class="services-line-hour">{{ formatedDataServices[ms.name][d]['form'].closing }}</div>
                      </div>
                      <div class="services-line-bckg"></div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col class="services-duplicate" :offset="4" :span="12"
                v-if="formatedDataServices[ms.name][d]['form'].isClosed">
                <el-select v-model="formatedDataServices[ms.name][d]['duplicate']"
                  placeholder="Dupliquer le service de" @change="duplicateDataService(ms.name, d, $event)">
                  <el-option v-for='item in getOpenedFormatedData(ms.name)' :key="item.idDay"
                    :label="'Dupliquer le service de ' + item.label" :value="item.label"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-form class="services-day-parameters" v-if="visibilityForm[d][ms.name]"
              ref="formatedDataServices[ms.name][d]['form']" :model="formatedDataServices[ms.name][d]['form']">
              <el-row :gutter="40">
                <el-col :span="12">
                  <el-form-item label="Ouverture">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].opening"
                      @input="changeThenCallInputInit($event, 'opening', ms, d)" :picker-options="{
                        start: '05:30',
                        step: '00:15',
                        end: '23:30'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Fermeture">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].closing"
                      @input="changeThenCallPopulateCT($event, 'closing', ms, d)" :picker-options="{
                        start: '05:30',
                        step: '00:15',
                        end: '23:30'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Capacité">
                    <el-input-number :value="formatedDataServices[ms.name][d]['form'].capacity"
                      @input="changeSimple($event, 'capacity', ms, d)" :min="1">
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Capacité par tranche horaire">
                    <el-input-number :value="formatedDataServices[ms.name][d]['form'].capacityIntervalMain"
                      :key="formatedDataServices[ms.name][d]['form'].capacityIntervalMain"
                      @input="changeThenCallPopulateCTCheckInterval($event, 'capacityIntervalMain', ms, d)" :min="0">
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Durée d'un service">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].lenghtService"
                      @input="changeSimple($event, 'lenghtService', ms, d)" :picker-options="{
                        start: '00:30',
                        step: '00:30',
                        end: '3:30'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                  <el-form-item label="Première heure pour la prise de réservation">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].hMinTakeResa"
                      @input="changeAndUpdateMaxThenCallPopulateCT($event, 'hMinTakeResa', ms, d)" :picker-options="{
                        start: formatedDataServices[ms.name][d]['form'].opening,
                        step: '00:15',
                        end: formatedDataServices[ms.name][d]['form'].closing
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                  <el-form-item label="Dernière heure pour la prise de réservation">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].hMaxTakeResa"
                      @input="changeThenCallPopulateCT($event, 'hMaxTakeResa', ms, d)" :picker-options="{
                        start: formatedDataServices[ms.name][d]['form'].opening,
                        step: formatedDataServices[ms.name][d]['form'].intervalResa,
                        end: formatedDataServices[ms.name][d]['form'].closing
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                  <el-form-item label="Intervalle de réservation">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].intervalResa"
                      @input="changeAndUpdateMaxThenCallPopulateCT($event, 'intervalResa', ms, d)" :picker-options="{
                        start: '00:05',
                        step: '00:05',
                        end: '3:00'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].nbServices < 2">
                  <el-form-item label="Limite entre réservations">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].limitSecuChrono"
                      @input="changeSimple($event, 'limitSecuChrono', ms, d)" :picker-options="{
                        start: '00:15',
                        step: '00:15',
                        end: '2:00'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Nombre min de personnes par résa">
                    <el-input-number :value="formatedDataServices[ms.name][d]['form'].nbMinByResa"
                      @input="changeSimple($event, 'nbMinByResa', ms, d)" :min="1" :max="100"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Nombre max de personnes par résa">
                    <el-input-number :value="formatedDataServices[ms.name][d]['form'].nbMaxByResa"
                      @input="changeSimple($event, 'nbMaxByResa', ms, d)" :min="1" :max="100"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Limite avant annulation">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].limitAnnulation"
                      @input="changeSimple($event, 'limitAnnulation', ms, d)" :picker-options="{
                        start: '00:00',
                        step: '01:00',
                        end: '72:00'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Nombre max de résa pour le service">
                    <el-input-number :value="formatedDataServices[ms.name][d]['form'].nbMaxResa"
                      @input="changeSimple($event, 'nbMaxResa', ms, d)" :min="0" :max="9999"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12" style="min-height:70px">
                  <el-form-item label="Service invisible à la réservation en ligne" style="text-align:center">
                    <el-switch v-model="formatedDataServices[ms.name][d]['form'].invisible" active-color="#00cec0"
                      inactive-color="#e95d5d">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Fermeture automatique" style="text-align:center">
                    <el-switch v-model="formatedDataServices[ms.name][d]['form'].closeAuto" active-color="#00cec0"
                      inactive-color="#e95d5d">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].closeAuto">
                  <el-form-item label="Delai avant fermeture automatique">
                    <el-time-select :value="formatedDataServices[ms.name][d]['form'].closeAutoTime"
                      @input="changeSimple($event, 'closeAutoTime', ms, d)" :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '72:00'
                      }" :clearable="false" placeholder="Select time">
                    </el-time-select>
                  </el-form-item>
                </el-col>
                <!----- CASH  ----->
                <el-col :span="12">
                  <el-form-item label="Caution ou prépaiement" style="text-align:center">
                    <el-switch v-model="formatedDataServices[ms.name][d]['form'].cashOn" active-color="#00cec0"
                      inactive-color="#e95d5d">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].cashOn">
                  <el-form-item label="Type" style="text-align:center">
                    <el-select v-model="formatedDataServices[ms.name][d]['form'].cashType" placeholder="Type">
                      <el-option label="Caution" value="caution"></el-option>
                      <el-option label="Prépaiement" value="prepaiement"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].cashOn">
                  <el-form-item label="Prix / couverts" style="text-align:center">
                    <el-input class="inputEuro" placeholder="Prix / couverts"
                      v-model="formatedDataServices[ms.name][d]['form'].cashPrice"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formatedDataServices[ms.name][d]['form'].cashOn">
                  <el-form-item label="Couverts min." style="text-align:center">
                    <el-input class="inputCouv" placeholder="couverts min."
                      v-model="formatedDataServices[ms.name][d]['form'].cashCouv"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12"
                  v-if="formatedDataServices[ms.name][d]['form'].cashOn && formatedDataServices[ms.name][d]['form'].cashType === 'caution'">
                  <el-form-item label="Limite avant annulation" style="text-align:center">
                    <el-time-select v-model="formatedDataServices[ms.name][d]['form'].cashLimitHour" :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '72:00'
                    }" :clearable="true" placeholder="Limite avant annulation">
                    </el-time-select>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row class="services-day-parameters-btns" :gutter="20">
                <el-col :span="6">
                  <el-popover placement="right" width="200" trigger="manual"
                    v-model="popupValidCloseService[ms.name + d]" popper-class="popup-delete black-inputs">
                    <p>Si vous voulez supprimer ce service, merci d'indiquer votre mot de passe</p>
                    <el-input v-model="checkPassValue" type="password"></el-input>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" class="dark" type="primary"
                        @click="popupValidCloseService[ms.name + d] = false">Annuler</el-button>
                      <el-button type="primary" size="mini"
                        @click="closeService(ms.name, d, formatedDataServices[ms.name][d]['form'])">Confirmer</el-button>
                    </div>
                    <el-button slot="reference"
                      @click="popupValidCloseService[ms.name + d] = !popupValidCloseService[ms.name + d]" class="red">
                      Supprimer
                    </el-button>
                  </el-popover>
                </el-col>
                <el-col :span="6">
                  <el-button class="dark" @click="undoService(ms.name, d)">Annuler</el-button>
                </el-col>
                <el-col :span="12">
                  <el-button
                    @click="validService(ms.name, d, formatedDataServices[ms.name][d]['form'])">Valider</el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="link" @click='showHideLockedService'>Définir des plages d’ouverture / fermeture</div>
      <div v-if="getAllInfos.restoStripe" class="link" @click='showHideScreenCashList'>Définir des cautions ou des
        prépaiements occasionnels</div>
    </el-col>
  </el-row>
</el-container>
